module.exports = __webpack_public_path__ + "img/14.f0b7c4fb.gif";